import * as React from 'react'

interface IProps {
  children?: React.ReactNode
}

export function AuthFormError({ children }: IProps) {
  if (!children) {
    return null
  }

  return (
    <p
      role="alert"
      className="tw:m-0 tw:text-center tw:text-app-dense tw:text-destructive"
    >
      {children}
    </p>
  )
}
